import PropTypes from 'prop-types';

class ClientService {
  constructor() {
    this.id = 0;
    this.name = '';
    this.selected = false;
    this.weight = 0;
  }
}

export default ClientService;

export const propTypes = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  weight: PropTypes.number.isRequired,
});
